import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';

@Injectable({
  providedIn: 'root'
})
export class GamificationMainService {
  currentDate = new Date();

  data: any = {
    areaDescriptions: {
      'Rules': 'In this view, you will be able to see which games have the most participants and how many games are running currently.',
      'Challenges': 'See how many challenges are running currently and which challenge types have the most participants.',
      'Marketplace': 'Allows you to view how many new orders are in, which marketplace items are most popular, and other order and item status details.',
      'Awards': 'View which badges are being earned most, percentage of badges succesffully earned vs. unearned, the amount of badges awarded each day, and which players have earned each badge.',
    },
    availableTabs: [],
    availableTabsLoaded: false,
    coinHistory: null,
    totalAvailableCoins: null,
    hasGroupSelector: false,
    groupSelectorHtml: '',
    selectedLogins: [],
    selectedLoginsHash: {},
    savedSettings: {},
    settings: {
      OverviewDate: 'Today',
      OnboardingComplete: false,
      HiddenAreas: [],
    },
    globalSettings:{
        GamificationSettingsID: 0,
        CollectButton: false,
        Interval: 4,
        NumericValue: 3,
    },
    settingsLoaded: false,
    usersCoinsEarned: null,
    gameHistory: null,
    budgetHistorySettings: {
      DateRange: 'Month',
      Month: this.currentDate.getMonth(),
      Year: this.currentDate.getFullYear(),
    },
    visibleAreas: {
      Currency: false,
      Games: false,
      Challenges: false,
      Awards: false,
      Coins: false
    },
    glimpseSize: ''
  }

  ngOnInit(): void {
    this.loadLocalization();
    this.setHiddenAreas();
  }

  constructor(
    private cvApiService: CVApiService,
    private cvLocalizationService: CVLocalizationService
  ) { }

  setOverViewDate(value: string) {
    this.data.settings.OverviewDate = value;
  }

  setHiddenAreas() {
    let glimpseAreas = [
      "Currency",
      "Games",
      "Challenges",
      "Awards"
    ];

    let availableTabs = this.data.availableTabs.map((tab) => { tab.name });

    this.data.visibleAreas = availableTabs.reduce((visibleAreas, area) => {
      visibleAreas[area] = this.data.settings.HiddenAreas.indexOf(area) > 0;
      return visibleAreas;
    });

    let showGlimpseAreas = glimpseAreas.filter((area) => {
      return this.data.visibleAreas[area];
    });

    //Glimpse width
    switch (showGlimpseAreas.length) {
      case 0:
        this.data.glimpseSize = '';
        break;
      case 1:
        this.data.glimpseSize = 'col-12';
        break;
      case 2:
        this.data.glimpseSize = 'col-12 col-md-6';
        break;
      case 3:
        this.data.glimpseSize = 'col-12 col-md-6 col-lg-4';
        break;
      case 4:
        this.data.glimpseSize = 'col-12 col-md-6 col-lg-4 col-xl-3';
        break;
    }
  }

  loadLocalization() {
    this.cvLocalizationService.GetSection("Command_Center").then((map) => {
      this.data.areaDescriptions['Challenges'] = map['Challenges_Message'][0];
      this.data.areaDescriptions['Awards'] = map['Awards_Message'][0];
    });
  }

  async loadGroupSelector() {
    try {
      const url = "/api/v1/gamification/group-selector";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.groupSelectorHtml = response.data;
        this.data.hasGroupSelector = true;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading group selector: " + error.message);
    }
  }

  async loadGroupSelectorLogins() {
    try {
      const url = "/api/v1/gamification/group-selector/logins";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.selectedLogins = response.data;
        this.data.selectedLoginsHash = {};
        this.data.selectedLogins.forEach((login) => {
          this.data.selectedLoginsHash[login] = true;
        });
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading logins group selector: " + error.message);
    }
  }

  async loadCoinHistory(interval) {
    try {
      const url = "/api/v1/gamification/coin-history?interval=" + interval;
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.coinHistory = response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading coin history: " + error);
    }
  }

  async loadBudgetHistory(budgetSettings, GroupID, GroupLevel) {
    try {
      const url = "/api/v1/gamification/budget-history/groupId/" + GroupID + "/groupLevel/" + GroupLevel + "?interval=" + budgetSettings.DateRange + "&month=" + (budgetSettings.Month + 1) + "&year=" + budgetSettings.Year;
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.data.coinHistory = response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading budget history: " + error.message);
    }
  }

  async loadTotalAvailableCoins() {
    try {
      const url = "/api/v1/gamification/coins/total";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.totalAvailableCoins = response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading total available coins: " + error.message);
    }
  }

  async loadUserCoinEarnings() {
    try {
      const url = "/api/v1/gamification/coins/earned";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.usersCoinsEarned = response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading coin earnings per user: " + error.message);
    }
  }

  async loadAvailableTabs() {
    try {
      const url = "/api/v1/gamification/tabs";
      let response = await this.cvApiService.get(url);
      if (response.status_code == 200) {
        this.data.availableTabs = response.data;
        this.data.availableTabsLoaded = true;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading command center tabs: " + error.message);
    }
  }

  async loadSettings() {
    try {
      const url = "/api/v1/gamification/settings";
      let response = await this.cvApiService.get(url);

      if (response.status_code == 200) {
        this.data.settings = response.data;
        this.data.savedSettings = JSON.parse(JSON.stringify(response.data));
        this.data.settingsLoaded = true;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading settings: " + error.message);
    }
  }

  async saveSettings(settings) {
    try {
      const url = "/api/v1/gamification/settings";
      let response = await this.cvApiService.post(url, JSON.stringify(settings));

      if (response.status_code >= 200 && response.status_code < 300) {
        this.data.savedSettings = JSON.parse(JSON.stringify(settings));
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error saving gamification settings: " + error.message)
    }
  }

  async loadGlobalSettings () {
    try {
      const url = "/api/v1/gamification/globalsettings";
      let response = await this.cvApiService.get(url);

      if (response.status_code >= 200 && response.status_code < 300) {
        this.data.globalSettings = response.data;
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error loading gamification global settings: " + error.message)
    }
  }

  async saveGlobalSettings(settings) {
    try {
      const url = "/api/v1/gamification/globalsettings";
      let response = await this.cvApiService.post(url, JSON.stringify(settings));

      if (response.status_code >= 200 && response.status_code < 300) {
        if (settings.GamificationSettingsID == 0 && this.data.globalSettings.GamificationSettingsID == 0) {
            this.loadGlobalSettings();
        }
      } else {
        throw response;
      }
    } catch (error) {
      showErrorMessage("Error saving gamification global settings: " + error.message);
    }
  }
}
